import { Link } from "@tanstack/react-router"
import {
  NavigationMenu,
  NavigationMenuList,
  NavigationMenuItem,
} from "./NavigationMenu"
import { ToptaalLogo } from "../../../../assets/icons"
import { NotificationCount } from "../../notification-count/NotificationCount"
import type { MTTEntities } from "../../../../types/roles/mttRoles"

export type NavigationMenuRoutes<TRoutePath extends string> = {
  label: string
  path: TRoutePath
  teacherOnly?: boolean
  notificationCount?: number
  permissionEntity?: MTTEntities
}

interface NavigationMenuWrapperProps<TRoutePath extends string> {
  navigationItems: NavigationMenuRoutes<TRoutePath>[]
  profileDropdown?: React.ReactNode
  logo?: React.ReactNode
  isTodoLoading?: boolean
  isCorrespondenceLoading?: boolean
}

export function NavigationMenuWrapper<TRoutePath extends string>({
  navigationItems,
  profileDropdown,
  isTodoLoading,
  isCorrespondenceLoading,
  logo = <ToptaalLogo className="mr-5 w-8 h-8" />,
  ...props
}: NavigationMenuWrapperProps<TRoutePath>) {
  return (
    <NavigationMenu
      className="bg-primary-medium-blue w-full flex justify-between"
      {...props}
    >
      <div className="screen-container flex justify-between items-center">
        <NavigationMenuList>
          <NavigationMenuItem>
            <Link to="/">{logo}</Link>
          </NavigationMenuItem>
          {navigationItems.map((item) => {
            const isTodoItem = item.path === "/todo"
            const isCorrespondenceItem = item.path === "/correspondentie"

            const isLoadingCount =
              (isTodoItem && isTodoLoading) ||
              (isCorrespondenceItem && isCorrespondenceLoading)

            return (
              <NavigationMenuItem key={item.path}>
                <Link
                  to={item.path as unknown as string}
                  className="navigation-menu-link flex flex-row gap-2 p-4 items-center"
                >
                  {isLoadingCount && (
                    <span
                      className="inline-block h-5 w-5 rounded-full bg-secondary-coral"
                      aria-label={`${item.label} notificaties laden`}
                    />
                  )}

                  {!isLoadingCount &&
                    item.notificationCount !== undefined &&
                    item.notificationCount > 0 && (
                      <NotificationCount count={item.notificationCount} />
                    )}

                  {item.label}
                </Link>
              </NavigationMenuItem>
            )
          })}
        </NavigationMenuList>
        {profileDropdown && (
          <NavigationMenuList>
            <NavigationMenuItem>{profileDropdown}</NavigationMenuItem>
          </NavigationMenuList>
        )}
      </div>
    </NavigationMenu>
  )
}
